/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
/**
* This file is for managing system image resources. These resources are expected
* to be stored in a JSON file that will be loaded by require directly.
*/

import {
    svgToImage,
    iconPathToName,
} from '../utils/tools';
import { xml2js } from 'xml-js';
"use strict";

/**
 * Imports all system images from client/lib/images
 * @returns {Object}
 */
function importAll() {
    const r = require.context('../images/', true, /\.svg$/);
    var cache = {};

    r.keys().forEach((key) => {
        let data = r(key);
        let json = xml2js(data, { compact: true });

        cache[key.substring(2, key.length - 4).toLowerCase()] = {
            svgText: data,
            height: json.svg._attributes.height,
            width: json.svg._attributes.width,
            friendlyName: json.svg._attributes['data-friendly-name'],
        };
    });

    return cache;
}

const dohImage = svgToImage([
    "<?xml version=\"1.0\" encoding=\"utf-8\"?> ",
    "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" ",
    "width=\"128\" height=\"128\" viewBox=\"0 0 128 128\" style=\"enable-background:new 0 0 128 128; fill: #000000;\" xml:space=\"preserve\"> ",
    "<style type=\"text/css\"> ",
    ".st0{font-family:'MyriadPro-Regular';} ",
    ".st1{font-size:33px;} ",
    "</style> ",
    "<text id=\"XMLID_1_\" transform=\"matrix(1 0 0 1 25.4864 76.1967)\" class=\"st0 st1\">DOH!</text> ",
    "<g id=\"XMLID_2_\"> ",
    "<path id=\"XMLID_13_\" d=\"M108.4,106.1c-2.5,1-4.9,2-7.4,3s-5,1.9-7.5,2.8c-2.5,1-5,1.8-7.5,2.7c-2.5,0.9-5,1.8-7.5,2.7l-7.5,2.6 ",
    "c-2.5,0.9-5,1.7-7.6,2.5c-5,1.7-10.1,3.3-15.2,4.8l-2.1,0.6l-1.7-1.5l-5.7-5.1c-1.9-1.7-3.8-3.4-5.7-5.1l-2.8-2.6l-2.8-2.6 ",
    "c-1.8-1.8-3.7-3.5-5.5-5.3l-5.4-5.4l-5.4-5.5C7.5,91,4,87.3,0.4,83.7l-0.9-0.9L0,81.7c0.8-2.4,1.6-4.9,2.3-7.3l1.1-3.7 ",
    "c0.4-1.2,0.7-2.4,1.1-3.7c0.7-2.4,1.4-4.9,2.1-7.4s1.3-4.9,1.9-7.4c0.7-2.5,1.3-4.9,1.9-7.4c0.6-2.5,1.2-5,1.8-7.4l1.7-7.5l1.6-7.5 ",
    "l0.3-1.2l1.4-0.5l15-5.3l7.5-2.6c2.5-0.9,5-1.7,7.6-2.5c5-1.6,10.1-3.2,15.2-4.8l15.2-4.8L80.1,0l2,1.8c3.8,3.4,7.7,6.7,11.4,10.2 ",
    "c1.9,1.7,3.8,3.4,5.7,5.1c1.9,1.7,3.8,3.4,5.6,5.2c3.7,3.5,7.4,7,11.1,10.5c1.9,1.7,3.7,3.5,5.5,5.3l5.5,5.3l1.9,1.8l-0.7,2.3 ",
    "c-1.4,4.9-3,9.8-4.5,14.6c-1.5,4.9-3.1,9.7-4.7,14.6l-2.4,7.3c-0.8,2.4-1.6,4.8-2.5,7.3c-0.8,2.4-1.7,4.8-2.6,7.2 ",
    "c-0.9,2.4-1.8,4.8-2.7,7.2l-0.1,0.2L108.4,106.1z M107.9,105.2c0.4-2.4,0.8-4.9,1.3-7.3c0.4-2.5,0.9-5,1.4-7.5s1-5,1.5-7.5l1.5-7.5 ",
    "c1.1-5,2.1-10,3.2-15s2.2-10,3.4-14.9l1.2,4.1l-5.8-5c-1.9-1.7-3.9-3.3-5.8-5c-3.8-3.4-7.7-6.7-11.5-10.1c-1.9-1.7-3.8-3.4-5.7-5.1 ",
    "c-1.9-1.7-3.8-3.4-5.6-5.2c-3.8-3.4-7.4-7-11.2-10.5l4.4,1l-15.4,4.2c-5.1,1.4-10.2,2.8-15.4,4.1c-2.6,0.7-5.1,1.4-7.7,2L34,21.9 ",
    "l-15.5,3.7l1.7-1.7L17.9,31l-2.3,7.3c-0.8,2.4-1.5,4.9-2.2,7.3C12.7,48,12,50.5,11.3,53c-0.7,2.5-1.4,4.9-2,7.4 ",
    "c-0.7,2.5-1.3,4.9-1.9,7.4c-0.4,1.2-0.7,2.4-1,3.7l-0.9,3.7c-0.6,2.5-1.1,5-1.6,7.5l-0.6-2c3.9,3.3,7.9,6.4,11.9,9.7l6,4.8l5.9,4.9 ",
    "c1.9,1.7,3.9,3.3,5.8,5l2.9,2.5l2.9,2.6c1.9,1.7,3.8,3.4,5.6,5.2l5.6,5.2l-3.7-0.9c5.1-1.4,10.2-2.8,15.4-4.1 ",
    "c2.6-0.7,5.1-1.3,7.7-1.9l7.7-1.9c2.6-0.6,5.2-1.2,7.8-1.8c2.6-0.6,5.2-1.2,7.8-1.7c2.6-0.5,5.2-1.1,7.8-1.6 ",
    "C102.8,106.1,105.3,105.7,107.9,105.2z\"/> ",
    "</g> ",
    "</svg>"
].join(''), 0, 0);

const imageLibrary = importAll();
const designerImageLibrary = {};

export default {
    dohImage,
    imageLibrary,
    designerImageLibrary,
    getImage(sysName) {
        let internalSysName = sysName.toLowerCase();

        if (imageLibrary[internalSysName] != null) {
            return imageLibrary[internalSysName];
        }
        else if (designerImageLibrary[internalSysName] != null) {
            return designerImageLibrary[internalSysName];
        }
        else {
            // If not found, attempt to correct the name...WR
            internalSysName = iconPathToName(internalSysName);
            if (imageLibrary[internalSysName] != null) {
                return imageLibrary[internalSysName];
            }
            else if (designerImageLibrary[internalSysName] != null) {
                return designerImageLibrary[internalSysName]
            }
        }
        return dohImage;
    }
};
